import {Reducer} from 'redux'
import {UsersActionTypes, UsersState} from './types';
import UsersService from "../../services/UsersService";
import {Tab} from "../../tabs/Tab";
import {User} from "../../models/User";
import {TabsService} from "../../tabs/TabsService";

// Type-safe initialState!
const initialState: UsersState = {
	list: []
}

// Thanks to Redux 4's much simpler typings, we can take away a lot of typings on the reducer side,
// everything will remain type-safe.
const reducer: Reducer<UsersState> = (state = initialState, action) => {
	switch (action.type) {
		case UsersActionTypes.FETCH_ALL_REQUEST: {
			UsersService.getAll()
			return { ...state, loading: true }
		}
		case UsersActionTypes.FETCH_ALL_COMPLETED: {
			return { ...state, loading: false, list: action.payload}
		}
		case UsersActionTypes.FETCH_ONE_REQUEST: {
			UsersService.getOne(action.payload)
			return { ...state, loading: true }
		}
		case UsersActionTypes.FETCH_ONE_COMPLETED: {
			// updates list but I do not see usage of this at the moment
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1, action.payload)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case UsersActionTypes.SAVE_REQUEST: {
			UsersService.save(action.payload)
			return { ...state, loading: true }
		}
		case UsersActionTypes.SAVE_COMPLETED: {
			let newUser = action.payload
			let foundIndex = state.list.findIndex(element => element.id === newUser.id)
			state.list.splice(foundIndex, 1, action.payload)
			let newList = [...state.list]
			return { ...state, list: newList}
		}
		case UsersActionTypes.DELETE_REQUEST: {
			UsersService.delete(action.payload)
			return { ...state, loading: true }
		}
		case UsersActionTypes.DELETE_COMPLETED: {
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case UsersActionTypes.DELETE_MULTIPLE_REQUEST: {
			UsersService.deleteUsers(action.payload)
			return { ...state, loading: true }
		}
		case UsersActionTypes.DELETE_MULTIPLE_COMPLETED: {
			action.payload.forEach((item: any) => {
				let foundIndex = state.list.findIndex(element => element.id === item.id)
				state.list.splice(foundIndex, 1)
			});
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		default: {
			return state
		}
	}
}

// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
export {reducer as UsersReducer}
